export default {"src":"/_next/static/media/adapools.17a3e3f5.svg","height":1024,"width":1024};